import { pick } from "__barrel_optimize__?names=pick!=!lodash-es";
import { localAESStorage } from "@/util/storage";
import { USER_TEMPLATE_KEY } from ".";
import { loginSuccessCallback } from "./loginSuccessCallback";
const handler = {
  async updateUserInfo(state, payload) {
    state.userState = payload;
    localAESStorage.setItem(USER_TEMPLATE_KEY, pick(payload, "userId", "userImage", "userName"), 30 * 24 * 3600);
    if (payload.userId) {
      var
      // 登录成功的回调
      _loginSuccessCallback_callback;
      (_loginSuccessCallback_callback = loginSuccessCallback.callback) === null || _loginSuccessCallback_callback === void 0 ? void 0 : _loginSuccessCallback_callback.call(loginSuccessCallback, payload);
      loginSuccessCallback.callback = undefined;
    }
  },
  clearUserInfo(state) {
    state.userState = {};
    localAESStorage.removeItem(USER_TEMPLATE_KEY);
  },
  getIsLogin(state) {
    var _state_userState_userId;
    return !!((_state_userState_userId = state.userState.userId) === null || _state_userState_userId === void 0 ? void 0 : _state_userState_userId.trim());
  },
  getIsMine(state, id) {
    var _state_userState_userId, _state_userState_userId1;
    if (!((_state_userState_userId = state.userState.userId) === null || _state_userState_userId === void 0 ? void 0 : _state_userState_userId.trim())) return false;
    return ((_state_userState_userId1 = state.userState.userId) === null || _state_userState_userId1 === void 0 ? void 0 : _state_userState_userId1.trim()) === id;
  }
};
export default handler;